<template>
  <ModalSlot
    ref="sdzModal"
    @close="onClose"
    @clickOutside="onClose"
    :title="getTitle"
    :width="getModalSize"
    custom-class="verify-account__action-required"
    theme="light"
    z-index="999999"
    hide-confirm-button
    hide-cancel-button
    close-icon
  >
    <div class="verify-account__container">
      <p>Identificamos uma inconsistência na verificação de sua conta. Por motivos de segurança sua conta foi bloqueada, entre em contato com nosso suporte para regularizar sua situação.</p>
      <v-btn
        @click="openSupport"
        class="error"
        block
      >
        Falar com suporte
      </v-btn>
    </div>
  </ModalSlot>
</template>

<script>
import ModalSlot from '@/components/sdz/SdzModal.vue'
import { ACCOUNT_STATUS, ACCOUNT_STATUS_TITLE } from '@/helpers/verified-account'
export default {
  name: 'VerifyAccountActionRequired',
  components: {
    ModalSlot
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.show) {
      this.$refs.sdzModal.open()
    }
  },
  computed: {
    getTitle() {
      return ACCOUNT_STATUS_TITLE[ACCOUNT_STATUS.refused]
    },
    getModalSize() {
      if (this.$isMobile()) return 'auto'
      return '360'
    }
  },
  methods: {
    openSupport() {
      this.onClose()
      window.zE('messenger', 'open')
    },
    onClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="stylus" scoped>
.btn-complementary-style-2
  background var(--complementary-style-2) !important

  &:hover
    background var(--complementary-style-3) !important

.verify-account__action-required
  .verify-account__title
    margin-top 16px

    h3
      font-size 27px
      color var(--primary)

  .verify-account__container
    width 360px
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding 16px 16px 0
    margin 8px 0 0

    p
      line-height 24px

@media (max-width: 959px)
  .verify-account__action-required
    .verify-account__container
      width auto
</style>

